/**
 * TabNavigation - Tab导航组件
 * 用于GDS追溯页面的信息分类展示
 */

import React, { useState } from 'react';
import './TabNavigation.css';

function TabNavigation({ tabs = [], defaultActiveKey = 0 }) {
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  if (!tabs || tabs.length === 0) {
    return <div className="tab-navigation-empty">暂无内容</div>;
  }

  return (
    <div className="tab-navigation-container">
      {/* Tab标签栏 */}
      <div className="tab-navigation-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-navigation-item ${activeKey === index ? 'active' : ''}`}
            onClick={() => setActiveKey(index)}
          >
            {tab.icon && <span className="tab-icon">{tab.icon}</span>}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab内容区 */}
      <div className="tab-navigation-content">
        {tabs[activeKey] && tabs[activeKey].content}
      </div>
    </div>
  );
}

export default TabNavigation;

